/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Create_Tenant_ButtonInputs */

const es_login_create_tenant_button = /** @type {(inputs: Login_Create_Tenant_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear empresa gratis`)
};

const en_login_create_tenant_button = /** @type {(inputs: Login_Create_Tenant_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create one for free`)
};

/**
* | output |
* | --- |
* | "Create one for free" |
*
* @param {Login_Create_Tenant_ButtonInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_create_tenant_button = /** @type {((inputs?: Login_Create_Tenant_ButtonInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Create_Tenant_ButtonInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_create_tenant_button(inputs)
	return en_login_create_tenant_button(inputs)
});
export { login_create_tenant_button as "login.create_tenant_button" }